import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-dark text-white text-center p-3 mt-auto">
      <div className="container">
        <p>&copy; {new Date().getFullYear()} Polonsky Academy. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
